/*
 * @Author: Ryan
 * @Date: 2026-01-16
 * @Description: E-Commerce Landing 首页
 */
import { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import LandingLayout from '@/landing/components/LandingLayout';
import ECommerceHeroSection from '@/landing/components/templates/ECommerceHeroSection';
import FeaturesSection from '@/landing/components/templates/FeaturesSection';

// 非首屏组件懒加载
const ShowcaseCarouselSection = dynamic(
  () => import('@/landing/components/templates/ShowcaseCarouselSection'),
);
const FeatureCardsSection = dynamic(
  () => import('@/landing/components/templates/FeatureCardsSection'),
);
const ImageCardsSection = dynamic(
  () => import('@/landing/components/templates/ImageCardsSection'),
);
const TikTokExploreMoreSection = dynamic(
  () => import('@/landing/components/templates/TikTokExploreMoreSection'),
);
const ComparisonTableSection = dynamic(
  () => import('@/landing/components/templates/ComparisonTableSection'),
);
const ROIStatsSection = dynamic(
  () => import('@/landing/components/templates/ROIStatsSection'),
);
const FAQSection = dynamic(() => import('@/landing/components/templates/FAQSection'));
const FooterCTASection = dynamic(
  () => import('@/landing/components/templates/FooterCTASection'),
);
import {
  AI_AVATAR_CARDS,
  AI_AVATAR_CONFIG,
  COMPARISON_COLUMNS,
  COMPARISON_ROWS,
  COMPARISON_TABLE_CONFIG,
  FAQ_CONFIG,
  FAQ_LIST,
  FEATURE_CARDS,
  FEATURE_CARDS_CONFIG,
  FEATURES_CONFIG,
  FEATURES_LIST,
  FOOTER_CTA_CONFIG,
  HERO_CONFIG,
  POWERFUL_TOOLS_CONFIG,
  ROI_STATS_CARDS,
  ROI_STATS_CONFIG,
  SEO_CONFIG,
  SHOWCASE_CONFIG,
  SHOWCASE_ITEMS,
  VIDEO_TRANSLATOR_CARDS,
  VIDEO_TRANSLATOR_CONFIG,
} from '@/landing/e-commerce/config';

const Index = () => {
  return (
    <LandingLayout seo={SEO_CONFIG}>
      <ECommerceHeroSection
        title={HERO_CONFIG.title}
        description={HERO_CONFIG.description}
        ctaText={HERO_CONFIG.ctaText}
        ctaUrl={HERO_CONFIG.ctaUrl}
        // logoImage={HERO_CONFIG.logoImage}
      />

      <FeaturesSection
        title={FEATURES_CONFIG.title}
        subtitle={FEATURES_CONFIG.subtitle}
        features={FEATURES_LIST}
        ctaText={FEATURES_CONFIG.ctaText}
      />

      <ShowcaseCarouselSection
        title={SHOWCASE_CONFIG.title}
        subtitle={SHOWCASE_CONFIG.subtitle}
        items={SHOWCASE_ITEMS}
        ctaText={SHOWCASE_CONFIG.ctaText}
        ctaUrl={SHOWCASE_CONFIG.ctaUrl}
        autoPlayInterval={SHOWCASE_CONFIG.autoPlayInterval}
        autoPlay
      />

      <FeatureCardsSection
        title={FEATURE_CARDS_CONFIG.title}
        highlightTitle={FEATURE_CARDS_CONFIG.highlightTitle}
        subtitle={FEATURE_CARDS_CONFIG.subtitle}
        cards={FEATURE_CARDS}
        ctaText={FEATURE_CARDS_CONFIG.ctaText}
        ctaUrl={FEATURE_CARDS_CONFIG.ctaUrl}
      />

      <ImageCardsSection
        title={AI_AVATAR_CONFIG.title}
        highlightTitle={AI_AVATAR_CONFIG.highlightTitle}
        subtitle={AI_AVATAR_CONFIG.subtitle}
        cards={AI_AVATAR_CARDS}
        ctaText={AI_AVATAR_CONFIG.ctaText}
        ctaUrl={AI_AVATAR_CONFIG.ctaUrl}
        theme="dark"
      />

      <ImageCardsSection
        title={VIDEO_TRANSLATOR_CONFIG.title}
        subtitle={VIDEO_TRANSLATOR_CONFIG.subtitle}
        cards={VIDEO_TRANSLATOR_CARDS}
        ctaText={VIDEO_TRANSLATOR_CONFIG.ctaText}
        ctaUrl={VIDEO_TRANSLATOR_CONFIG.ctaUrl}
        theme="light"
      />

      <TikTokExploreMoreSection title={POWERFUL_TOOLS_CONFIG.title} />

      <ComparisonTableSection
        title={COMPARISON_TABLE_CONFIG.title}
        subtitle={COMPARISON_TABLE_CONFIG.subtitle}
        columns={COMPARISON_COLUMNS}
        rows={COMPARISON_ROWS}
      />

      <ROIStatsSection
        title={ROI_STATS_CONFIG.title}
        cards={ROI_STATS_CARDS}
        ctaText={ROI_STATS_CONFIG.ctaText}
        ctaUrl={ROI_STATS_CONFIG.ctaUrl}
      />

      <FAQSection title={FAQ_CONFIG.title} faqs={FAQ_LIST} />

      <FooterCTASection
        title={FOOTER_CTA_CONFIG.title}
        subtitle={FOOTER_CTA_CONFIG.subtitle}
        ctaText={FOOTER_CTA_CONFIG.ctaText}
        ctaUrl={FOOTER_CTA_CONFIG.ctaUrl}
      />
    </LandingLayout>
  );
};

export default Index;

/** SSG 静态生成 - 优化 TTFB */
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: 3600, // ISR: 每小时重新生成
  };
};
